export default __webpack_public_path__ + "static/media/tableau.b6ad42c8.svg";